/* React */
import React from 'react';
import { Layout, Table } from 'antd';
import { GetComponentProps } from 'rc-table/lib/interface';



/************************************************
 * 전역변수 선언영억
 ************************************************/


const Com9999p = (props:any) => {
    const [dataSource, setDataSource] = React.useState([]);
    const { Content }  = Layout;

    React.useEffect(() => {
        setDataSource(props.dataSource);
    }, [props]);

    /**
     * 기능 : onRow
     */
    const onRow: GetComponentProps<number> = (_record:any, _rowIndex) => ({
        onClick: (event) => {
            const target = event.target as HTMLElement;
            const iconName = target.getAttribute('data-icon');

            if (iconName === 'delete') {
                let tmpDataSource = [...dataSource];
                tmpDataSource = tmpDataSource.filter((item:any) => {
                    return item['rowKey'] !== _record['rowKey'];
                });

                setDataSource(tmpDataSource);

                if (props.onRow && typeof props.onRow === 'function') {
                    props.onRow(_record, _rowIndex);
                }
            }
            

        },
    });

	return (
        <Layout>
            <Content>
                <div key={'tableKey' + props.id} style={{ height: 200, display: 'flex', flexDirection: 'column' }}>
                    <Table dataSource={dataSource}
                        columns={props.columns}
                        size={props.size ? props.size : 'small'}
                        rowKey={props.rowKey}
                        bordered={!props.hasOwnProperty('bordered') ? true : props.bordered}
                        style={!props.hasOwnProperty('style') ? {y:40, width:'100%', flex:1} : props.style}
                        showHeader={!props.hasOwnProperty('showHeader') ? true : props.showHeader}
                        pagination={false}
                        scroll={{y:200}}
                        onRow={onRow}
                    /> 
                </div>
            </Content>
        </Layout>
    );
}

export default Com9999p;